import { Button, Popover, Space, Typography } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

export const InformationTitle = ({ text, info, type = "secondary", fontStyle = {} }) => (
  <Space size="small">
    <Typography.Text style={fontStyle} type={type}>{text}</Typography.Text>
    <Popover
      trigger="click"
      placement="topLeft"
      content={() => (
        <Space className="info-on-title">
          <InfoCircleOutlined style={{ color: "#FAAD14" }} />
          <Typography.Text>{info}</Typography.Text>
        </Space>
      )}>
      <Button
        type="link"
        size="small"
        shape="circle"
        icon={<InfoCircleOutlined />} />
    </Popover>
  </Space>
)

InformationTitle.propTypes = {
  text: PropTypes.string,
  info: PropTypes.string,
  type: PropTypes.string,
  fontStyle: PropTypes.object
}